import { uniqBy } from 'lodash';
import { helpers } from '../../common/lib';
import getInitialState from '../get-initial-state';
import { actionTypes } from './actions';

const initialState = {
  ...getInitialState.list(),
  locations: [],
};

export default function (state = { ...initialState }, action) {
  switch (action.type) {
    case actionTypes.BRANCH_LOCATIONS_GET_SUCCESS: {
      const { branchLocations } = action.payload;
      return helpers.getListReducer(state, branchLocations);
    }
    default: {
      return state;
    }
  }
}
